<template>
  <div class="editor" :id="id"></div>
</template>
<script>
import E from "wangeditor";
import Cookie from "js-cookie";
export default {
  props: {
    height: {
      type: Number,
      default: 200
    },
    sourceId: {
      type: String,
      default: ""
    },
    sourceType: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    fileID:{
      type:String,
      default:"",
    },
    tableName:{
      type:String,
      default:"",
    },
    id:{
      type:String,
      default:"box",
    },
  },
  data() {
    return {
      isChange:false,    //定义判读是否改变的变量
    };
  },
  mounted() {
    this.initE();
  },
  methods: {
    initE() {
      this.editor = new E("#"+this.id);
      //这里各位小伙伴可以查询官网，根据自己的需求进行菜单栏调整
      this.editor.config.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "lineHeight",//行高
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        //"emoticon", // 表情
        "image", // 插入图片
        "video",//插入视频
        "table", // 表格
        //"code", // 插入代码
        "undo", // 撤销
        "redo" // 重复
      ];
      //为true，则上传后的图片转为base64编码，为false,则上传图片到服务器，二者不能同时使用
      this.editor.config.uploadImgShowBase64 = true;
      //服务器接收的上传图片的属性名
      this.editor.config.uploadFileName = "file";
      //服务器上传图片的接口地址
      this.editor.config.uploadImgServer =
      process.env.VUE_APP_FileAddress+ "Main/addFileByRichText?appID=1&fileSystemKey="+process.env.VUE_APP_FileSysToken+"&typeID=0&parentID=0&objectID="+this.fileID
      +"&useType=10&tableName="+this.tableName,
      // this.editor.config.uploadImgHeaders = {
      //   Authorization: Cookie.get("Authorization")
      // };
      this.editor.config.uploadImgHeaders = {
        Authorization: process.env.VUE_APP_FileSysToken
      };
      this.editor.config.uploadImgParams = {
        sourceId: this.sourceId,
        sourceType: this.sourceType
      };
      this.editor.config.uploadImgTimeout = 60 * 1000;
      // 默认限制图片大小是 5M ，可以自己修改。
      this.editor.config.uploadImgMaxSize = 10 * 1024 * 1024; // 10M
      this.editor.config.height = this.height;
      this.editor.config.uploadImgShowBase64 = true;
      // 限制类型,可自定义配置,默认为： ['jpg', 'jpeg', 'png', 'gif', 'bmp']
      this.editor.config.uploadImgAccept = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "webp"
      ];
      //上传图片过程中钩子函数
      this.editor.config.uploadImgHooks = {
        // 上传图片之前
        before: function(xhr) {
           console.log("before")
          // console.log(xhr);
          // // 可阻止图片上传
          // return {
          //   prevent: true,
          //   msg: "需要提示给用户的错误信息",
          // };
        },
        // 图片上传并返回了结果，图片插入已成功
        success: function(xhr) {
          console.log("success", xhr);
        },
        // 图片上传并返回了结果，但图片插入时出错了
        fail: function(xhr, editor, resData) {
          console.log("fail", resData);
        },
        // 上传图片出错，一般为 http 请求的错误
        error: function(xhr, editor, resData) {
          console.log("error", xhr, resData);
        },
        // 上传图片超时
        timeout: function(xhr) {
          console.log("timeout");
        }
      };
      this.editor.config.uploadVideoServer =
      process.env.VUE_APP_FileAddress+ "Main/addFileByRichText?appID=1&fileSystemKey="+process.env.VUE_APP_FileSysToken+"&typeID=0&parentID=0&objectID="+this.fileID
      +"&useType=10&tableName="+this.tableName,// 配置服务器端地址
      // 自定义 header
      this. editor.config.uploadVideoHeaders = {
        Authorization: process.env.VUE_APP_FileSysToken
      }
      this.editor.config.uploadVideoName = 'file'//后端接收上传文件的参数名（这是配置视频）
       //上传视频的回调
       this.editor.config.uploadVideoHooks = {
            // 上传视频之前
    /*        before: function(xhr) {
              console.log(xhr)
              // 可阻止视频上传
              return {
                prevent: true,
                msg: '需要提示给用户的错误信息'
              }
            },*/
            // 视频上传并返回了结果，视频插入已成功
            success: function(xhr) {
              console.log('success', xhr)
            },
            // 视频上传并返回了结果，但视频插入时出错了
            fail: function(xhr, editor, resData) {
              console.log('fail', resData)
            },
            // 上传视频出错，一般为 http 请求的错误
            error: function(xhr, editor, resData) {
              console.log('error', xhr, resData)
            },
            // 上传视频超时
            timeout: function(xhr) {
              console.log('timeout')
            },
            // 视频上传并返回了结果，想要自己把视频插入到编辑器中
            // 例如服务器端返回的不是 { errno: 0, data: { url : '.....'} } 这种格式，可使用 customInsert
            customInsert: function(insertVideoFn, result) {
              // result 即服务端返回的接口
              console.log('customInsert', result)
              // insertVideoFn 可把视频插入到编辑器，传入视频 src ，执行函数即可
              //result.data 就是url的值
              insertVideoFn(result.data[0].url)
            }
          }

      this.editor.config.onchange = html => {
        this.isChange = true;
        //触发父组件的方法，并传值
        this.$emit("change", html);
      };


      //初始化富文本编辑器时显示的内容
     
      this.editor.create();
      this.editor.txt.html(this.text);
    },
    reaload()
    {
        this.editor.txt.html("");
    }
  },
  watch: {
    text:
        {
          handler:function (val,oldV) {
            if(!this.isChange){
             
              this.editor.txt.html(val);
            }
            this.isChange= false;
          }
        }
  }
};
</script>
